import React from 'react'
import './index.scss'
import Sidebar from '@Components/Sidebars/Sidebar'
import AddAlternativeTitle from '@Components/WorkRegistrationSubs/AddAlternativeTitle'
import ModalPortal from '@Components/Popups/ModalPortal'

interface AddAlternativeTitlesSidebarProps {
    open: boolean
    onClose: () => void
}

export const AddAlternativeTitlesSidebar = ({ open, onClose }: AddAlternativeTitlesSidebarProps) => (
    <ModalPortal isOpen={open} onClose={onClose}>
        <Sidebar onClose={onClose}>
            <AddAlternativeTitle closePopupFunc={onClose} />
        </Sidebar>
    </ModalPortal>
)

export default AddAlternativeTitlesSidebar
